<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col
        :cols="currentSociety === undefined ? '12' : '6'"
        class="list-overflow"
      >
        <v-list>
          <v-list-item-group v-model="currentSociety">
            <v-list-item
              v-for="society in socData"
              :key="society.key"
            >
              <v-list-item-title>{{ society.name }}</v-list-item-title>
              <v-list-item-action>
                <v-icon>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-if="currentSociety !== undefined"
        cols="6"
      >
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="socData[currentSociety].name"
                :rules="[rules.required]"
                :append-icon="iconAvailable"
                :label="$t('akito.account-name')"
                dense
                :background-color="colorAvailable"
                @change="checkName()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="socData[currentSociety].sub_type"
                :items="$t('profile.subscriptions')"
                :label="$t('profile.sections.account.sub')"
                readonly
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="socData[currentSociety].sub_renewal"
                :label="$t('akito.sub-renewal')"
                readonly
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="formatDateExpire(socData[currentSociety].id_soc)"
                :label="$t('akito.date-expire')"
                readonly
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-btn
                color="primary"
                :disabled="isButtonDisabled"
                @click="updateSocData(socData[currentSociety])"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileAccessConnector } from "../../Database/ProfileAccessConnector.js";
import { ProfileUserConnector } from "../../Database/ProfileUserConnector.js";
import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";

// Libs
const moment = require("moment");

export default {
  data() {
    return {
      accessConnector: new ProfileAccessConnector(this.$store.state.user),
      userConnector: new ProfileUserConnector(this.$store.state.user),
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      currentSociety: undefined,
      accessesData: [],
      isButtonDisabled: false,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        min: (v) => v.length >= 8 || this.$t("field.min-8"),
        regex: (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t("profile.sections.user.mail"),
      },
      socData: [],
      dtExpire: [],
      nameAvailable: true,
    };
  },
  computed: {
    iconAvailable() {
      if (this.nameAvailable) {
        return "mdi-check-circle";
      } else {
        return "mdi-close-circle";
      }
    },
    colorAvailable() {
      if (this.nameAvailable) {
        return "";
      } else {
        return "error";
      }
    },
  },
  created() {
    this.getListAccess();
    this.getDateExpire();
    this.getSociety();
  },
  methods: {
    checkName() {
      this.societyConnector
        .checkDuplicate(11, this.socData[this.currentSociety].name, this.socData[this.currentSociety].id_soc)
        .then((isAvailable) => {
          this.nameAvailable = isAvailable;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    formatDateExpire(soc) {
      let tempo = "";

      this.dtExpire.forEach((element) => {
        if (element.soc_id == soc) {
          tempo = element.dt_expire;
        }
      });

      if (tempo == "" || tempo == "Invalid date") {
        tempo = "00-00-0000";
      }

      return tempo;
    },
    getDateExpire() {
      this.societyConnector.getDateExpire().then((listDate) => {
        // TODO: format in db server
        this.dtExpire = listDate.map((data) => {
          return {
            soc_id: data.soc_id,
            dt_expire: moment(data.dt_expire).format("DD-MM-YYYY"),
          };
        });
      });
    },
    getSociety() {
      this.societyConnector.getSoc().then((response) => {
        this.socData = response;

        this.socData.forEach((element, index) => {
          if (element.sub_renewal == "Invalid date") {
            element.sub_renewal = "00-00-0000";
          }

          if (element.id_soc == 0) {
            this.socData.splice(index);
          }
        });
      });
    },
    getListAccess() {
      this.accessConnector.getListAccess().then((accesses) => {
        // TODO: format in db server
        this.accessesData = accesses.map((data) => {
          return {
            value: data.id_right,
            text: data.name,
          };
        });
      });
    },
    updateSocData(soc) {
      // Prevent double click on create
      this.isButtonDisabled = true;

      // Confirm last check of name available
      if (this.nameAvailable) {
        // Update user in DB
        this.societyConnector
          .updateSoc(soc)
          .then(() => {
            // Undefined select to deselect edit
            this.currentSociety = undefined;
          })
          .finally(() => {
            // Permit to reenable create button
            this.isButtonDisabled = false;
          });
      }
    },
  },
};
</script>

<style></style>
